import useAuth from 'hooks/useAuth';

export default function useHandleAccess() {
  const { db } = useAuth();
  const handleAccess = (email: string, access: boolean) => {
    const accessRef = db.collection('access');
    access && accessRef.doc(email).set({ enabled: true });
    !access && accessRef.doc(email).delete();
  };

  return handleAccess;
}
